import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShareClicked.meta';

export type UseTrackShareClickedParams = {
  location: 'action_bar' | 'context_menu';
};

export const useTrackShareClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackShareClicked = useCallback(
    (params: UseTrackShareClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShareClicked };
};
